import { BaseEventProps } from "../../types";

export type EventProps = BaseEventProps;

export enum MediatorEventType {
  SET_USER_STATE = "SET_USER_STATE",
  GEOCOMPLY_STATUS = "GEOCOMPLY_STATUS",
  REMOVE_GEO_TOKEN = "REMOVE_GEO_TOKEN"
}

export interface EventData {
  type: MediatorEventType;
  payload: {
    region: string;
    status: string;
    removedBy: string;
  };
}
